<script setup>
import { useTransactionConfirmationTracking } from "@/mixins/tracking/transaction-confirmation";
import { useTrackingPage } from "@/mixins/tracking/all-pages";
import apiClientCommande from "@/services/http/api-drive/client/commande";
import { loadPageWithLoader } from "@/utils/webpack-helper";
import { useContextStore } from "@/store/context";
import { usePanierStore } from "@/store/panier";

definePageMeta({
  middleware: "authenticated",
  layout: "commander"
});

const commande = ref(null);
const app = useNuxtApp();

const { trackTransactionConfirmation } = useTransactionConfirmationTracking();

const { trackPage } = useTrackingPage();

const {
  clearByTypePanier: clearPanier,
  clearClonePanier,
  setClonePanierFromLocalStorage
} = usePanierStore();
const { layout } = storeToRefs(useContextStore());

onMounted(() => {
  setClonePanierFromLocalStorage();
  trackTransactionConfirmation(commande.value);
  clearClonePanier();
});

const component = computed(() => {
  return loadPageWithLoader(
    lazyComponents[
      `/components/pages/commander/confirmation/en-attente/${layout.value}.vue`
    ]
  );
});
</script>

<template>
  <component :is="component" />
</template>
